import { render, staticRenderFns } from "./PensionHistorique.vue?vue&type=template&id=6ca30082&"
import script from "./PensionHistorique.vue?vue&type=script&lang=js&"
export * from "./PensionHistorique.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports